<template>
  <div class="chartOne">
    <!-- <div id="codMain" class="codMain" @mouseenter="onmouserin()"></div> -->
    <div class="charttitle">
      <span style="margin-right: 6px;">
        Pollutant Removal Efficiency
      </span>
      <el-select ref="select" default-first-option v-model="value2" filterable value-key="index"
        @change="handleCommand2(value2)" @blur="clickOutSide()" size="mini" v-if="showchart">
        <el-option v-for="item in pollutanthandle" :key="item.index" :label="item.title" :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="waterchart" v-if="showchart">
      <el-tabs v-model="activeName" @tab-click="handleClick" :value="activeName">
        <el-tab-pane :label="item.label" :name="item.value" v-for="(item, index) in tablist" :key="index" lazy>
          <div class="chartdetail" style="width: 100%" v-if="activeName == item.value" @mouseenter="onmouserin()">
            <barmain :barmain="'myChart' + item.title" :ChartData="chartdata" style="width: 100%;margin: 0 auto"
              class="tabchart">
            </barmain>
            <div v-if="chartdata == []">
              No Relevant Data Available
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else class="nodata">
      <div>
        <img src="../../../assets/1@2x (1).png" alt="">
        <div>
          No Relevant Data Available
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import commonApi from "@/api/common.js";
import barmain from "./charts/barmian.vue";
// import config from '@/utils/config';;

export default {
  components: { barmain },
  props: {
    // codMain: String,
    // ChartData: Object,
  },
  data() {
    return {
      tablist: [
        {
          label: 'Daily',
          value: 'day'
        },
        {
          label: 'Monthly',
          value: 'month'
        }
      ],
      activeName: null,
      value2: null,
      pollutanthandle: [
      ],
      chartdata: null,
      chartlist: null,
      showchart: false,
      openIndex: null,
    };
  },
  beforeDestroy() {
    // this.myChart.clear()
    // clearInterval(this.timer);
  },
  mounted() {
    this.openmodule = this.$route.query.module;
    this.openIndex = this.$route.query.index;

    // console.log(this.ChartData);
    this.getdata('day');

    // this.timer = window.setInterval(() => {
    //   setTimeout(this.initChart(), 0);
    // }, 300000);
  },
  computed: {
    ...mapState(["theme"]),
  },
  watch: {
    "$store.state.open"(newVal, oldVal) {
      // this.codChart.resize();
      // this.myChart.resize()
    },
    theme() {
      // this.myChart.clear()
      this.getdata('day');
    },

  },
  methods: {
    async getdata(type) {
      const { data: res } = await this.$http.get("/modules/removal/rate/get", {
        params: {
          module: this.openmodule,
          length: 11,
          data_type: type,
        },
      });

      this.pollutanthandle = []
      if (res.data.result[0].legend[0].yAxis.length == 0) {
        // console.log(3222222222222222222222222222);
        this.showchart = false
      } else {
        this.showchart = true
        // this.$forceUpdate()
      }
      res.data.result.map((v, index) => {

        this.pollutanthandle.push(
          {
            title: v.title + '(' + v.legend[0].unit + ')',
            index: index
          }
        )
      })

      this.activeName = type
      this.value2 = this.pollutanthandle[0].title
      this.chartdata = res.data.result[0]
      this.chartlist = res.data.result
      // console.log(res.data.result[0]);

    },
    handleClick() {
      // console.log(tab);
      console.log(this.activeName);
      this.getdata(this.activeName);

    },
    handleCommand2() {
      console.log(this.value2);
      this.chartdata = this.chartlist[this.value2.index]

    },
    onmouserin() {
    },
    changevalue(a, b) {
      let some = [a, b];
      return some;
    },

    initChart() {
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        // console.log(this.theme);
        let that = this
        this.myChart = this.$echarts.init(
          document.getElementById('codMain'),
          this.theme
        );
        this.myChart.setOption(this.initOption);
        this.myChart.getZr().on('click', function (param) {
          if (param.offsetY > 60) {
            that.$emit("closedrawer");
          }
        });
      });
    },
    clickOutSide() {
      this.$refs.select.blur()
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  // width: 100%;
  // height: 100%;
  // margin: 0 auto;
  background-color: #212121FF;
  // border-radius: 26px;
  border-radius: 26px;

  .waterchart {
    height: 200px;


  }

  .charttitle {
    padding-top: 23px;
    margin-left: 45px;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24.38px;
    color: #C5C5C5FF;
  }

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  .codMain {
    width: 100%;
    height: 90%;
    margin: 0 auto;
  }

  h4 {
    padding-top: 10px;
    padding-left: 36px;
    font-size: 16px;
    color: rgb(76, 76, 76);
  }

  .el-tabs {
    background-color: transparent;
    color: #000;
    border-radius: 17px;
    right: 0px;
    top: 0px;
    // width: 315px;
    height: 36px;
    position: relative;
  }

  .nodata {
    margin-top: 50px;
    padding-bottom: 27px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: middle;
    color: rgba(197, 197, 197, 1);

    img {
      height: 150px
    }
  }

  // .el-tabs__content {
  //   width: 1000px;
  // }


  ::v-deep .el-tabs__nav-wrap::after {
    position: static !important;
  }

  ::v-deep .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 0px;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #276fb7 !important;
  }


  ::v-deep .el-tabs__active-bar.is-top {
    // height: 36px;
    // width: 80px !important;
    // border-radius: 20px;
    // top: 0px !important;
    // left: -50% !important;
    // position: absolute !important;
    // z-index: 1;
  }


  ::v-deep .el-tabs__item.is-active {
    color: #ffffff !important;
    z-index: 2;
    height: 36px;
    width: 100px !important;
    border-radius: 20px;
    background-color: rgb(36, 102, 168) !important
  }

  ::v-deep .el-tabs__nav.is-top {
    float: right;
    right: 4%;
  }


  ::v-deep .el-tabs__item {
    padding: 0 20px !important;
    width: 60px;
    height: 36px;
    line-height: 36px;
    box-sizing: border-box;
    display: inline-block;
    position: relative !important;
    color: #000000 !important;
    z-index: 2;
    font-size: 14px;
    text-align: center;
  }

  ::v-deep .el-input--mini {
    font-size: 14px;
  }
}
</style>
